// #region Imports

import * as $ from "jquery";

// #endregion Imports

const CONSULTANT_DELAY_MS = 10000;

// #region Exports

export function initialize(): void {
    bindToggleButtons();
}

// #endregion Exports

// #region Private functions

function bindToggleButtons(): void {
    $('[data-toggle]').on('click', handleToggle);
    $('#exam-mode-toggle').on('change', handleExamToggle);
    $('#exam-mode-toggle-consultant').on('change', handleExamToggleConsultant);
}

function handleToggle(event): void {
    event.preventDefault();
    const openClass = 'expanded';

    $(this).toggleClass(openClass);
    $(this.dataset.toggle).toggleClass(openClass);
}

function setExamMode(endpoint: 'set' | 'setConsultant', active: boolean): Promise<void> {
    return fetch(`/api/exammode/1.0/${endpoint}?active=${active}`, {
        method: 'GET',
        credentials: 'include'
    }).then(response => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
    });
}

function isConsultantActive(): boolean {
    // Byt till rätt id/selektor för konsultkryssrutan
    const checkbox = document.getElementById('exam-mode-toggle-consultant') as HTMLInputElement | null;
    return checkbox?.checked ?? false;
}

function showConsultantOverlay(activating: boolean, hideAvailableText = false): void {
    const overlay = document.getElementById('exam-mode-consultant-overlay');
    if (!overlay) return;

    overlay.classList.add(
        activating
            ? 'exam-mode-overlay-activate'
            : 'exam-mode-overlay-inactivate'
    );

    const availableText = overlay.querySelector('.exam-mode-info-available') as HTMLElement | null;
    if (availableText) {
        availableText.hidden = hideAvailableText;
    }

    overlay.style.display = 'flex';

    setTimeout(() => {
        const cancelButton = overlay.querySelector(
            activating
                ? '.exam-mode-info-active button'
                : '.exam-mode-info-inactive button'
        ) as HTMLButtonElement | null;

        cancelButton?.focus();
    }, 150);
}

function reloadSoon(): void {
    setTimeout(() => window.location.reload(), 600);
}

function handleExamToggle(event): void {
    const checkbox = event.target as HTMLInputElement;
    const active = checkbox.checked;
    const consultantWillBeDisabled = active && isConsultantActive();

    const run = () => {
        const disableOther = active ? setExamMode('setConsultant', false) : Promise.resolve();

        disableOther
            .then(() => setExamMode('set', active))
            .then(reloadSoon)
            .catch(err => console.error('Fel vid anrop:', err));
    };

    if (consultantWillBeDisabled) {
        // Konsultläget är på och stängs av: visa overlay och vänta som i konsultflödet
        showConsultantOverlay(false, true);
        setTimeout(run, CONSULTANT_DELAY_MS);
    } else {
        run();
    }
}

function handleExamToggleConsultant(event): void {
    const checkbox = event.target as HTMLInputElement;
    const active = checkbox.checked;

    showConsultantOverlay(active);

    setTimeout(() => {
        const disableOther = active ? setExamMode('set', false) : Promise.resolve();

        disableOther
            .then(() => setExamMode('setConsultant', active))
            .then(reloadSoon)
            .catch(err => console.error('Fel vid anrop:', err));
    }, CONSULTANT_DELAY_MS);
}

// #endregion Private functions